export const IS_LOCAL = process.env.NEXT_PUBLIC_CONNECTOR_BUILDER_LOCAL_MODE
export const PRODUCTION_PLATFORM_API_URI =
  process.env.NEXT_PUBLIC_PROD_ENGINE_API_URI ??
  process.env.https://api.connections.me.wlloyalty.net
export const PLATFORM_API_URI = process.env.https://api.connections.me.wlloyalty.net
export const PLATFORM_UI_URI = process.env.https://engine.connections.me.wlloyalty.net
